export const DeleteDocumentModal: string = 'DeleteDocumentModal';
